<template>
  <div class="panelNagusia">
    <div class="ui breadcrumb">
      <a class="section" @click="goTo('/dashboard')">Home</a>
      <i class="right angle icon divider"></i>
      <a class="active section" @click="goTo('/inventory')">Inventario y Actuaciones</a>
      <i class="right angle icon divider"></i>
      <a class="active section" @click="goTo('/inventory/stock/list')">Stocks</a>
      <i class="right angle icon divider"></i>
      <a class="active section">Detalle Stock</a>
    </div>

    <div v-if="!data" class="ui active centered inline loader"></div>
    <div v-if="data" class="ui header">
      <h1 class="content">{{ data.stock_name }}</h1>
      <button id="idBtnEdit" class="ui black right floated button button-size" type="button"
        v-on:click="editStockProduct">Guardar</button>
      <button v-if="data.column_reservation_id === null" class="ui right floated button button-size"
        :class="{ loading: isLoading, disabled: isLoading }" type="button" v-on:click="columnBooking">Reservar</button>
      <button v-else class="ui right floated button button-size" type="button"
        :class="{ loading: isLoading, disabled: isLoading }" v-on:click="unreserveColumn">Quitar
        reserva</button>
    </div>

    <div v-if="data" class="ui stackable divided grid container"
      :class="(data.column_reservation_id === null) ? 'three column' : 'four column'">
      <div class="row">
        <div class="column">
          <h4 class="ui dividing header">Características</h4>
          <div class="form ui">
            <div class="field">
              <label>Modelos de máquinas</label>
              <div class="ui icon input fluid">
                <input type="text" v-model="data.apt_models" readonly />
              </div>
            </div>
            <div v-if="data.n_slots" class="field">
              <label>Nº Slots</label>
              <input type="text" v-model="data.n_slots" readonly>
            </div>
            <div v-if="data.provider" class="field">
              <label>Fabricante</label>
              <input type="text" v-model="data.provider_name" readonly>
            </div>
          </div>
        </div>

        <div class="column">
          <h4 class="ui dividing header">Datos propios</h4>
          <div class="form ui">
            <div v-if="data.apt_name" class="field">
              <label>APT</label>
              <div class="ui icon input fluid">
                <input type="text" v-model="data.apt_name" readonly>
              </div>
            </div>

            <div v-if="data.store_name" class="field">
              <label>Almacén</label>
              <div v-if="editStoreMode" class="ui fluid action input">
                <sui-dropdown fluid search selection :options="storesOptions" v-model="data.store_id" placeholder="Almacenes" style="flex: 1;"/>

                <template v-if="showEditStoreButtons">
                  <div class="ui buttons">
                    <button id="idBtnEditStoreCancel" class="ui red icon button" style="border-radius: 5px 0px 0px 5px;" :class="{ loading: isSavingStoreCancel, disabled: editStoreButtonsDisabled }" @click="editStoreCancelClick">
                      <i class="x icon"></i>
                    </button>
                    <div class="or"></div>
                    <button id="idBtnEditStoreOK" class="ui green icon button" :class="{ loading: isSavingStoreOk, disabled: editStoreButtonsDisabled }" @click="editStoreOKClick">
                      <i class="check icon"></i>
                    </button>
                  </div>
                </template>
              </div>

              <div v-else class="ui fluid action input">
                <input id="inputEditStore" type="text" v-model="data.store_name" readonly />
                <button id="btnEditStore" class="ui teal icon button" @click="editStoreClick">
                  <i class="edit icon"></i>
                </button>
              </div>
            </div>

            <div class="field">
              <label>ID</label>
              <div class="ui icon input fluid">
                <input type="text" v-model="data.product_identifier" readonly>
              </div>
            </div>
            <div class="field">
              <label>ID Fabricante</label>
              <div class="ui icon input fluid">
                <input type="text" :id="'productid_' + data.id" v-model='data.product_identifier_prov'
                  placeholder="ID Fabricante">
              </div>
            </div>
            <div class="field">
              <label>Fecha garantia</label>
              <input type="datetime-local" v-model="data.warranty_date">
            </div>
            <div class="field">
              <label>Fecha recepción</label>
              <input type="datetime-local" v-model="data.receive_date">
            </div>
            <div class="field">
              <label>Observaciones</label>
              <textarea rows='3' v-model="data.observations"></textarea>
            </div>
          </div>
        </div>


        <div class="column">
          <h4 class="ui dividing header">Datos financieros</h4>
          <div class="form ui">
            <div class="field">
              <label>Proveedor</label>
              <sui-dropdown fluid search selection :options="providerOptions" v-model='data.purchase_provider_id'
                placeholder="Proveedores" />
            </div>
            <div class="field">
              <label>Fecha compra</label>
              <input type="datetime-local" v-model="data.purchase_date">
            </div>
            <div class="field">
              <label>Precio compra</label>
              <input type="text" placeholder="0.00" v-model="data.purchase_price" min="0"
                v-on:keydown="keysAllowed($event, data.purchase_price)">
            </div>
            <div class="field">
              <label>Amortización</label>
              <input type="number" v-model="data.amortization" placeholder="Amortización en años" min="0">
            </div>
            <div class="field">
              <label>Fecha venta</label>
              <input type="datetime-local" v-model="data.sale_date">
            </div>
            <div class="field">
              <label>Precio venta</label>
              <input type="text" placeholder="0.00" v-model="data.sale_price" min="0"
                v-on:keydown="keysAllowed($event, data.sale_price)">
            </div>
            <div class="field">
              <label>Cliente venta</label>
              <input type="text" v-model="data.sale_client" placeholder="Cliente al que se le ha vendido">
            </div>
          </div>
        </div>

        <div v-if="data.column_reservation_id !== null" class="column">
          <h4 class="ui dividing header">Datos Reserva</h4>
          <div class="form ui">
            <div v-if="data.column_reservation_name" class="field">
              <label>Reserva</label>
              <input type="text" v-model="data.column_reservation_name" readonly>
            </div>
            <div v-if="data.column_reservation_administrator_name" class="field">
              <label>Reservado por</label>
              <input type="text" v-model="data.column_reservation_administrator_name" readonly>
            </div>
            <button class="ui basic fluid button"
              @click="openBlank('/inventory/column/reservation/info/' + data.column_reservation_id)">Ver
              reserva</button>
          </div>
        </div>

      </div>
    </div>

    <br>
    <div v-if="data">
      <h4 v-if="rows.length > 0" class="ui dividing header">Actuaciones</h4>
      <div v-if="rows.length > 0" class="ui stackable one column divided grid container">
        <div class="row">
          <div class="column">
            <form class="ui form">
              <table class="ui selectable collapsing table">
                <thead>
                  <tr>
                    <th class="azpian">ID</th>
                    <th class="azpian">APM</th>
                    <th class="azpian">Actuación</th>
                    <th class="azpian">Fecha Actuación</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="val in rows" :key="val.id" :id="'idLine_' + val.id" @click="viewProductDetail(val)"
                    class="clickable-row">
                    <td :id="'idAction_' + val.id"> {{ val.action_id }} </td>
                    <td :id="'idAptName_' + val.id"> {{ val.apt_name }} </td>
                    <td :id="'idTypeName_' + val.id"> {{ val.action_type_name }} </td>
                    <td :id="'idActionDate_' + val.id"> {{ val.action_date }} </td>
                  </tr>
                </tbody>
              </table>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { hapiickApi } from '@/api/hapiickApi';
import BookingModal from '../../tools/BookingModal';
import { userNotification } from '../../tools/Utils';
export default {
  name: 'stockProductDetails',
  props: ['stock_product_id'],
  data() {
    return {
      data: null,
      historyData: null,
      stockAptModelOptions: [],
      role: null,
      rows: [],
      providerOptions: [],
      storesOptions: [],
      isLoading: false,

      editStoreMode: false,
      originalStoreId: null,

      isSavingStoreOk: false,
      isSavingStoreCancel: false,
      editStoreButtonsDisabled: false,
      showEditStoreButtons: false,
    }
  },

  async created() {
    this.role = JSON.parse(localStorage.admin).role;
    this.admin_id = JSON.parse(localStorage.admin).id;
    if (this.role === 'master' || this.role === 'admin') {
      this.getDataCombos()
      this.getStockProductInfo()
    } else {
      this.$router.replace('/inventory')
    }
  },

  watch: {
  'data.store_id'(newVal) {
    if (this.editStoreMode) {
      this.showEditStoreButtons = newVal !== this.originalStoreId;
    }
  }
},

  methods: {

    initializeComponente() {
      this.data = null
      this.isLoading = false
      this.getStockProductInfo()
    },

    async getDataCombos() {
      await hapiickApi().post('/v2/shipments/filters', {
        admin_id: this.admin_id,
        PurchaseProvider: true,
        Store:true,
      })
        .then(request => {
          let purchase_provider = [...request.data.data.purchase_provider];
          let stores = [...request.data.data.stores];

          this.fillPurchaseProviderOptions(purchase_provider)
          this.fillStoresOptions(stores)
        })
        .catch(() => console.log('error getting combo informations'))
    },
    fillStoresOptions(stores) {
      if (stores.length === 0) {
        this.storesOptions.push({
          'text': 'No hay almacenes',
        })
        return
      }

      for (let i = 0; i < stores.length; i++) {
        this.storesOptions.push({
          key: stores[i].Store.key,
          text: stores[i].Store.name,
          value: stores[i].Store.id,
        })
      }
    },
    
    fillPurchaseProviderOptions(providers) {
      if (providers.length === 0) {
        this.providerOptions.push({
          'text': 'No hay proveedores',
        })
        return
      }

      for (let i = 0; i < providers.length; i++) {
        this.providerOptions.push({
          text: providers[i].Provider.name,
          value: providers[i].Provider.id,
        })
      }
    },

    keysAllowed(event, data) {
      var e = event || window.event;
      var key = e.keyCode || e.which;

      if (key === 37 || key === 38 || key === 39 || key === 40 || key === 8 || key === 46) {// Permitir teclas: flechas, borrar y suprimir
        return;
      }

      const existePunto = data && data.includes("."); // Comprobar si el valor ya contiene un punto
      // Permitir números ((key >= 48 && key <= 57)) y un solo punto ((key === 46 || key === 190 || key === 110) && !existePunto)
      if ((key >= 48 && key <= 57) || (key === 46 || key === 190 || key === 110) && !existePunto) {
        return;
      }

      // Cualquier otra tecla no se introducira
      e.preventDefault();
    },

    async getStockProductInfo() {
      await hapiickApi().post('/v1/stocks/products/detail', {
        admin_id: this.admin_id,
        stock_product_id: this.stock_product_id
      })
      .then(request => {
        let product = JSON.parse(JSON.stringify(request.data.product));
        let history = JSON.parse(JSON.stringify(request.data.history));
        product.apt_models = product.apt_models.map((a => a.name));
        this.data = { ...product }
        this.rows = history

      })
      .catch((error) => {
        console.log(`Error getStockProductInfo: ${error}`)
        userNotification('error', 'Error', 'Error al obtener los datos', 0)
      })
    },

    editStoreClick() {
      this.editStoreMode = true;
      this.originalStoreId = this.data.store_id;
      this.showEditStoreButtons = false;
    },

    editStoreOKClick() {
      this.isSavingStoreOk = true;
      this.editStoreButtonsDisabled = true;

      hapiickApi().post('/v1/stocks/products/change-store', {
        admin_id: this.admin_id,
        stock_product_id: this.stock_product_id,
        orig_store_id: this.originalStoreId,
        dest_store_id: this.data.store_id
      }).then(request => {
        this.isSavingStoreOk = false;
        this.editStoreButtonsDisabled = false;

        if (request.data.status === 'OK') {
          const selectedStore = this.storesOptions.find(a => a.value === this.data.store_id);
          if (selectedStore) {
            this.data.store_name = selectedStore.text;
          }
          this.originalStoreId = this.data.store_id; 

          this.$swal({
            type: 'success',
            title: 'Los datos se han guardado correctamente',
            showConfirmButton: false,
            timer: 2500
          })

          this.editStoreMode = false;
        } else {
          this.msgError();
        }
     }).catch(() => {
          this.isSavingStoreOk = false;
          this.editStoreButtonsDisabled = false;
          this.msgError();
        })
    },

    editStoreCancelClick() {
      this.data.store_id = this.originalStoreId
      this.isSavingStoreCancel = false;
      this.editStoreButtonsDisabled = false;
      this.editStoreMode = false;
      this.showEditStoreButtons = false;
    },

    editStockProduct() {
      let x = document.getElementById('idBtnEdit');
      x.classList.add("loading");
      x.disabled = true;

      hapiickApi().post('/v1/stocks/products/edit', {
        admin_id: this.admin_id,
        data: this.data
      })
      .then(request => {
        x.classList.remove("loading");
        x.disabled = false;

        if (request.data.status === 'OK') {
          this.$swal({
            type: 'success',
            title: 'Los datos se han guardado correctamente',
            showConfirmButton: false,
            timer: 2500
          })
        } else if (request.data.message.duplicated_key) {
          let msg = "El ID de proveedor '" + request.data.message.duplicated_key + "' ya esta asignado para otra columna en el sistema"
          this.$swal({
            type: 'error',
            title: 'Error al guardar los datos',
            text: msg
          })
        } else {
          this.msgError();
        }
      })
      .catch(() => {
        this.msgError();
      })
    },

    async columnBooking() {
      this.isLoading = true
      const success = await BookingModal.openModal(this.stock_product_id, this.admin_id)
      if (success === undefined) return

      if (success) {
        userNotification('success', 'Tu reserva se ha realizado correctamente', '', 2500)
        this.initializeComponente()
      } else {
        userNotification('error', 'Tu reserva no se ha podido realizar', '', 0)
      }

    },

    unreserveColumn() {
      this.isLoading = true
      hapiickApi().post('/v1/stocks/products/unreserve', {
        admin_id: this.admin_id,
        stock_product_id: this.stock_product_id
      })
        .then((response) => {
          userNotification('success', 'La columna ya no está reservada', '', 2500)
          this.initializeComponente()
        })
        .catch((error) => {
          console.log(`Error unreserveColumn: ${error}`)
          return false
        })
    },

    viewProductDetail(val) {
      let routeData = this.$router.resolve('/inventory/action/info/' + val.action_id);
      window.open(routeData.href, '_blank');
    },

    msgError() {
      this.$swal({
        type: 'error',
        title: 'Error',
        text: 'Error al guardar los datos'
      });
    },

    openBlank(where) {
      let routeData = this.$router.resolve(where)
      window.open(routeData.href, '_blank')
    },

    goTo(where) {
      this.$router.push(where)
    },
  },

}
</script>

<style scoped>
.clickable-row {
  cursor: pointer;
}

.button-size {
  width: 150px;
}

.swal-custom {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  width: 100%;
}

</style>


// WEBPACK FOOTER //
// src/components/Inventory/stockProductDetails.vue